import {useQueryState} from 'shared/web';

import {
  isBulkOperationLinkOwner,
  parseBulkOperationLink,
  serializeBulkOperationLink,
} from '../utils/bulkOperationLink';

const BULK_OPERATION_QUERY_PARAM = 'bulkOperationId';

/** URL-linked operation state: parses the query value and resolves this grid's ownership. */
export function useBulkOperationLink(gridCode: string, presetInstanceId: string | undefined) {
  const [value, setValue, clearValue] = useQueryState(BULK_OPERATION_QUERY_PARAM, true);
  const link = parseBulkOperationLink(value);
  const ownsLink = isBulkOperationLinkOwner(link, gridCode, presetInstanceId);

  return {
    /** Raw query value; null when the URL carries no operation link. */
    value,
    /** Operation ID when this grid instance owns the link, null otherwise. */
    ownedBulkOperationId: ownsLink ? link.bulkOperationId : null,
    /** Operation ID from a completion notification that names no grid owner yet. */
    unscopedBulkOperationId: link !== null && link.gridCode === null ? link.bulkOperationId : null,
    /** Links an operation to this grid instance in the URL. */
    open: (bulkOperationId: string) =>
      setValue(serializeBulkOperationLink(gridCode, presetInstanceId, bulkOperationId)),
    /** Replaces the URL value verbatim, e.g. when adopting an unscoped notification link. */
    replace: setValue,
    clear: clearValue,
  };
}
